import React from 'react';
import {faBolt} from '@fortawesome/pro-solid-svg-icons';
import {
	Dialog,
	WithDialogProps,
	dialogClasses,
} from '@netx/core-components/Dialog';
import {styled} from '@netx/core-components/Theme';
import {CUSTOM_ACTION_ACTION_LABEL, CUSTOM_ACTION_TITLE} from '../../locales';
import {
	CustomActionCreated,
	CustomActionCreatedProps,
} from './CustomActionCreated';
import SubmitButton from '@netx/core-components/SubmitButton';

const CustomActionCreatedDialogRoot = styled(Dialog)(({theme}) => ({}));

const CustomActionCreatedRoot = styled(CustomActionCreated)(({theme}) => ({
	// padding: theme.spacing(0, 2, 2, 2),
}));

const CustomActionCreatedSubmitButton = styled(SubmitButton)(({theme}) => ({
	[theme.breakpoints.down('sm')]: {
		width: '100%',
	},
}));

export type CustomActionCreatedDialogProps =
	WithDialogProps<CustomActionCreatedProps>;

export const CustomActionCreatedDialogPrimitive = ({
	open,
	customAction,
	onClose,
	DialogProps,
	...props
}: CustomActionCreatedDialogProps) => {
	return (
		<CustomActionCreatedDialogRoot
			disableContentPadding
			fullWidth
			icon={faBolt}
			maxWidth="sm"
			open={open}
			title={CUSTOM_ACTION_TITLE.CUSTOM_ACTION}
			secondaryTitle={customAction.name}
			{...DialogProps}
			onClose={onClose}
			dialogActions={
				<CustomActionCreatedSubmitButton
					variant="text"
					label={CUSTOM_ACTION_ACTION_LABEL.DONE}
					onClick={() => onClose?.({}, 'escapeKeyDown')}
				/>
			}
		>
			<CustomActionCreatedRoot {...props} customAction={customAction} />
		</CustomActionCreatedDialogRoot>
	);
};

export const CustomActionCreatedDialog = CustomActionCreatedDialogPrimitive;

export default CustomActionCreatedDialog;
